import { getDataMapper, mapArray, mapField } from "@/shared";

export const mapExpenseTypeFromServer = getDataMapper({
    id: mapField("id", Number),
    title: mapField("title"),
    const: mapField("const"),
});
export const mapExpenseTypesFromServer = mapArray(mapExpenseTypeFromServer);
